import type { DocumentTab } from 'features/knowledgeDocumentViewer/types'
import { NAV_ITEMS_CONFIG } from 'features/navbar/navConfig'
import { SelectedTab } from 'features/navbar/types'
import { Home, Sparkle } from 'lucide-react'
import type { ComponentType } from 'react'

function destinationIcon(destinationKey: string): ComponentType {
  for (const [key, config] of Object.entries(NAV_ITEMS_CONFIG)) {
    if (key === destinationKey) return config.icon
  }
  return Home
}

/**
 * Icon for a workspace / document tab based on history and destination.
 */
export function getWorkspaceTabIcon(tab: DocumentTab): ComponentType {
  const item = tab.history[tab.currentIndex]

  if (item.type === 'search') {
    const hasSearch =
      item.searchState.query.trim().length > 0 ||
      item.searchState.browseAll === true
    if (hasSearch) {
      if (item.searchState.searchMode === 'agentic') return Sparkle
      return destinationIcon(SelectedTab.Documents)
    }
    if (tab.workspaceDestination) {
      return destinationIcon(tab.workspaceDestination)
    }
    return Home
  }

  if (item.type === 'destination') {
    return destinationIcon(item.destinationKey)
  }

  if (item.type === 'timeseries') {
    return destinationIcon(SelectedTab.ProcessData)
  }

  if (item.type === 'document') {
    return destinationIcon(SelectedTab.Documents)
  }

  return tab.workspaceDestination
    ? destinationIcon(tab.workspaceDestination)
    : Home
}
